<template>
  <ve-pie
    :data="chartData"
    :extend="extend"
    :title="extend.title"
    :legend="extend.legend"
    :tooltip="extend.tooltip"
    ref="chartPie"
  ></ve-pie>
</template>

<script>
import Vue from "vue";
import VCharts from "v-charts";
Vue.use(VCharts);
export default {
  name: "chartPie",
  props: ["chartData", "collapsed", "showNum"],
  data() {
    return {
      legend3ds: {
        is_3ds: "3DS",
        is_not_3ds: "без 3DS"
      },
      extend: {
        grid: {
          show: false,
          containLabel: false
        },
        color: ["#7c5691", "#23a9e6"],
        tooltip: {
          show: false,
          trigger: "item",
          formatter: function(param) {
            let name = param.name == "其他" ? "Остальные" : param.name,
              value = param.value,
              percent = param.percent;
            return name + "<br/>" + value + " (" + percent + "%)";
          }
        },
        legend: {
          type: "plain",
          orient: "horizontal",
          align: "auto",
          itemGap: 15,
          itemWidth: 7,
          padding: 20,
          bottom: 50,
          icon: "circle",
          formatter: param => {
            return (
              this.legend3ds[param] + " " + this.legendPercent(param) + "%"
            );
          },
          textStyle: {
            fontSize: 16,
            fontWeight: 500,
            fontFamily: "Avenir, Roboto, sans-serif"
          }
        },
        title: {
          show: true
        },
        series: {
          avoidLabelOverlap: false,
          selectedMode: "single",
          top: 0,
          center: ["50%", "38%"],
          radius: ["45%", "65%"],
          label: {
            normal: {
              position: "center",
              rich: {
                b: {
                  textStyle: {
                    color: "#dddddd",
                    fontSize: 16
                  }
                }
              },
              show: false,
              position: "center",
              formatter: param => {
                if (param.name == "其他") param.name = "";
                return (
                  this.legend3ds[param.name] +
                  "\n" +
                  param.value +
                  " (" +
                  param.percent +
                  "%)"
                );
              }
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "16",
                fontWeight: "500",
                fontFamily: "Avenir, Roboto, sans-serif",
                lineHeight: 20,
                color: "#484848"
              }
            }
          },
          labelLine: {
            normal: {
              show: false,
              length: 20,
              length2: 10
            }
          }
        }
      },
      settings: {
        dimension: ["code"],
        metrics: ["count"]
      }
    };
  },
  methods: {
    legendPercent(param) {
      if (this.chartData && param) {
        let arr = this.chartData.rows;
        let item = arr.find(el => el.code == param);
        let notItem = arr.filter(el => el.code != param);
        let count = item ? item.count : 0;
        let countAll = arr.reduce((a, b) => a.count + b.count);
        return ((count / countAll) * 100).toFixed(2);
      }
    }
  },
  computed: {
    chartSumm() {
      let arr = this.chartData.rows;
      let summ = 0;
      if (typeof arr != "undefined" && arr.length > 0) {
        arr.forEach(el => {
          summ = summ + el.count;
        });
      }
      return summ;
    }
  },
  watch: {
    collapsed(v) {
      setTimeout(() => {
        this.$refs["chartPie"].resize();
      }, 500);
    }
  }
};
</script>

<style lang="sass">

</style>